import { render } from "./ShowTasks.vue?vue&type=template&id=182a4cfb&scoped=true&ts=true"
import script from "./ShowTasks.vue?vue&type=script&lang=ts"
export * from "./ShowTasks.vue?vue&type=script&lang=ts"

import "./ShowTasks.vue?vue&type=style&index=0&id=182a4cfb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182a4cfb"]])

export default __exports__